<template>
  <div class="listing-page">
    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-8">
          <div class="text-video subheader">Educational Classroom Videos</div>
          <h1>{{ title }}</h1>
          <p>
            {{ description }}
          </p>
        </div>
      </div>
    </header>

    <resources-list :pagination="true" :params="params" />
  </div>
</template>

<script>
/* Video Resources
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ResourcesList
 * @methods:
 */

import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'VideosIndex',
  components: {
    ResourcesList,
  },
  data() {
    return {
      title: 'Videos',
      subtitle: 'Video resources',
      description:
        'Educational tuning-in videos to play for your students in the classroom, as well as educational and inspirational videos for you.',
      params: {
        country: this.$i18n.locale,
        payload: 'basic',
        perPage: 30,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        types: ['video'],
      },
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
};
</script>
